import React, { useContext } from 'react';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const ButtonCreatePartyInvolved = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { onAction, ticket } = useContext(TicketContext);

  const canAddPartyInvolved = permissions.ticketingUpdater.hasPermissions(
    userProfile,
    {
      regionId: ticket.region.id,
      buildingId: ticket.building.id,
      controlSystemId: ticket.controlSystem.id,
    },
  );

  return (
    <>
      {canAddPartyInvolved && (
        <IBTooltip content={permissions.ticketingUpdater.tooltip}>
          <Button
            type="primary"
            onClick={() => onAction('show-party-involved-entry', null)}
          >
            Add Party Involved
          </Button>
        </IBTooltip>
      )}
    </>
  );
};

export default ButtonCreatePartyInvolved;
